/**
 * Shared step-number → component map for V7 onboarding.
 *
 * Single source of truth so the admin preview (`OnboardingPreview.jsx`) and
 * the production wrapper (`OnboardingV7.jsx`) consume IDENTICAL imports —
 * no drift between the two surfaces when steps are added, renamed, or
 * renumbered.
 *
 * Folder names still reflect old numbering (e.g. 05-hunger-chips is step 3).
 * The KEY in this map is the NEW step number that matches
 * `ONBOARDING_STEPS[i].number` in `src/data/onboardingSteps.js`.
 *
 * Steps 9 (founder-note) and 10 (trust) intentionally have no component on
 * production — they're gated via `conditional: () => false` in
 * `onboardingSteps.js`. The admin preview ignores `conditional` so Mason
 * can still review the trust step's bracket-stub design while keeping it
 * hidden from real users until the founder video is shot and real
 * testimonials are collected.
 */

import WelcomeStep from '@/components/onboarding/steps/01-welcome/index.jsx'
import PrimaryGoalStep from '@/components/onboarding/steps/02-primary-goal/index.jsx'
import HungerChipsStep from '@/components/onboarding/steps/05-hunger-chips/index.jsx'
import HungerReflectionStep from '@/components/onboarding/steps/06-hunger-reflection/index.jsx'
import DoctrinalTrustStep from '@/components/onboarding/steps/07-doctrinal-trust/index.jsx'
import AiDemoStep from '@/components/onboarding/steps/08-ai-demo/index.jsx'
import StreakIntroStep from '@/components/onboarding/steps/09-streak-intro/index.jsx'
import MinistryMapSeedStep from '@/components/onboarding/steps/10-ministry-map-seed/index.jsx'
import TrustStep from '@/components/onboarding/steps/11-trust/index.jsx'
import ProfileDataStep from '@/components/onboarding/steps/12-profile-data/index.jsx'
import JourneySummaryStep from '@/components/onboarding/steps/13-journey-summary/index.jsx'
import ReminderPickerStep from '@/components/onboarding/steps/15-reminder-picker/index.jsx'
import PaywallTrialStep from '@/components/onboarding/steps/17-paywall-trial/index.jsx'
import HandoffStep from '@/components/onboarding/steps/18-handoff/index.jsx'

export const STEP_COMPONENTS = {
  1: WelcomeStep,
  2: PrimaryGoalStep,
  3: HungerChipsStep,
  4: HungerReflectionStep,
  5: DoctrinalTrustStep,
  6: AiDemoStep,
  7: StreakIntroStep,
  8: MinistryMapSeedStep,
  // 9 (founder-note) — placeholder, no component until video shoot
  10: TrustStep,
  11: ProfileDataStep,
  12: JourneySummaryStep,
  13: ReminderPickerStep,
  14: PaywallTrialStep,
  15: HandoffStep,
}
